import { Dimensions, Platform } from 'react-native'
import theme from './theme'
import { withOpacity } from '@/utils/functions.utils'
import { STORE_VIEW_MAP } from '@/components/stores/constants/constants.views'
const { width } = Dimensions.get('window')
const isWeb = Platform.OS === 'web'
//Rutas de los stores
export const routeStores = {
    appStoreUrl: 'https://apps.apple.com/ar/app/m%C3%A1s-branca/id6751004743',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.oravian.one.branca&pli=1',
}
export const SplashTheme = {
    splashGifWidth: '50%',
    splashGifHeight: width / 2,
}

//Colores Login
export const LoginTheme = {
    splashBackgroundColor: '#FFFFFE',
    splashGradientStartColor: 'white',
    splashGradientEndColor: 'white',
    loginGradientStartColor: 'white',
    loginGradientEndColor: 'white',
    splashTextColor: theme.colors.textSecondary,
    loginBackgroundColor: 'white',
    loginTextcolor: theme.colors.textPrimary,
    mainButtonBackgroundColor: theme.colors.colorPrimary,
    mainButtonTextColor: 'white',
    backButtonBackgroundColor: 'white',
    backButtonTextColor: theme.colors.colorPrimary,
    noteOffTextColor: theme.colors.textSecondary,
    errorMessageTextColor: theme.colors.error,
    timer: 4000,
    clientLogoMarginBottom: 0,
    clientLogoWidth: 148,
    clientLogoHeight: 128,
}

// Colores del Progress.Bar
export const colorUnfilled = theme.colors.textPrimary
export const colorFilled = theme.colors.colorPrimary
export const colorFilledBis = 'white'

// Colores de Filtros
export const colorFilterSelected = theme.colors.colorPrimary
export const colorFilterUnselected = theme.colors.mediumGray
export const colorFilterUnselectedPS = 'white'
export const colorFilterIconSelected = 'white'
export const colorFilterIconUnselected = theme.colors.colorPrimary
export const colorFilterTextSelected = 'white'
export const colorFilterTextUnselected = theme.colors.textPrimary

// AppBar
export const AppBarTheme = {
    navImage: require('./assets/client.png'),
    navImageWidth: Platform.OS != 'web' ? 70 : 100,
    navImageHeight: Platform.OS != 'web' ? 25 : 50,
    navImageTransform: [{ scale: 1 }],
}
export const AppGradientTheme = {
    mainGradientStart: 'white',
    mainGradientEnd: 'white',
    secondaryGradientStart: theme.colors.linearGradientStart,
    secondaryGradientEnd: theme.colors.linearGradientEnd,
}
//HeaderPost
export const HeaderPostTheme = {
    clientDefaultImage: require('./assets/iconWall.png'),
    clientNameDefaultText: 'Más Branca',
}
export const PostTagsTheme = {
    tagSelectedColor: theme.colors.colorPrimary,
    tagSelectedTextColor: 'white',
    tagUnselectedColor: 'white',
    tagUnselectedTextColor: colorFilterTextUnselected,
}
//Color de texto para botones/encuestas/evaluaciones/etc...
export const colorText = 'white'
export const colorButtonTextEnabled = 'white'
export const colorButtonTextDisabled = theme.colors.textSecondary
export const colorIcon = 'white'

//Background para Podcast
export const podcastBackground =
    'https://resources-one.s3.us-east-2.amazonaws.com/salesbook/contenido/iconos/podcastbackground.png'

// Trivia

export const triviaMainColor = theme.colors.colorPrimary
export const triviaMainColorOpacity = withOpacity(triviaMainColor, 0.2) //triviaMainColor + '33' //Opacidad 20%
const triviaSecondaryColor = theme.colors.colorSecondary
const triviaColorTitles = 'white'
const triviaRankingPositionColor = '#6890F6'
//Linear Gradient Mobile no acepta concatenaciones de string. Pasarlas a rgba
export const TriviaTheme = {
    tabsSelectedColor: triviaMainColorOpacity, //Opacidad 20%
    tabsUnselectedColor: withOpacity(triviaMainColor, 0.08), //Opacidad 8%
    triviaGradient: ['#ffffff', '#ffffff'],
    filledBlankTextColor: theme.colors.textPrimary,
    filledBlankSpaceBorderColor: triviaMainColor,
    triviaBackgroundColor: triviaMainColor,
    txtTriviaColorTitles: triviaMainColor,
    triviaColorTextFillingBlank: triviaSecondaryColor,
    triviaTimerColor: triviaMainColor,
    triviaTimerAssetColor: triviaMainColor,
    triviaTimerBorderColor: triviaMainColor,
    podiumUserTextcolor: theme.colors.textPrimary,
    podiumUserPointsTextcolor: triviaMainColor,
    rankingPositionTextColor: triviaRankingPositionColor,
    rankingUserTextColor: theme.colors.textPrimary,
    rankingPointsBorderColor: triviaRankingPositionColor,
    triviaCardTextColor: triviaMainColor,
    triviaGameNextButtonBackgroundColor: triviaSecondaryColor,
    timeOutGradient: ['#FBB6C4', '#ffffff'],
    finishedGradient: [triviaMainColorOpacity, '#AFFADE'],
    imageSelectedIconColor: triviaMainColor,
    imageCorrectIconColor: 'green',
    imageIncorrectIconColor: 'red',
    imageCorrectNotSelectedIconColor: 'green',
}

//RoundedTabs
export const RoundedTabsTheme = {
    selectedTextColor: !isWeb ? 'white' : triviaMainColor,
    unselectedTextColor: !isWeb ? 'white' : theme.colors.textPrimary,
}

export const HighLightColors = {
    correctBackgorundColor: 'green',
    correctBorderColor: 'green',
    correctTextColor: 'white',
    incorrectBackgorundColor: 'red',
    incorrectBorderColor: 'red',
    incorrectTextColor: 'white',
}
export const StepperColors = {
    previousStepColor: theme.colors.colorPrimary,
    currentStepColor: theme.colors.colorTertiary,
    nextStepColor: !isWeb ? 'white' : theme.colors.mediumGray,
}

//Gamification
export const GamificationTheme = {
    userImageBorderColor: 'white',
    stepPointsTextColor: 'white',
    currentUserLevelTextColor: 'black',
    stepFillColor: 'white',
    stepUnfillColor: theme.colors.darkGray,
    indicatorDefaultBorderColor: 'white',
    indicatorDefaultBackgroundColor: theme.colors.colorPrimary,
    gameLockedBorderColor: '#8F9BDA',
    gameLockedBackgroundColor: 'transparent',
    gameLockedTextColor: 'white',
    gameCompleteTextColor: theme.colors.colorSecondary,
    gamePendingGradientBackgroundColor: theme.colors.alert,
    gamePendingLevelTextColor: theme.colors.textPrimary,
    gamePendingPointsTextColor: theme.colors.textSecondary,
    dotBlockedBorderColor: theme.colors.darkGray,
    dotBloquedIconColor: 'white',
    dotCompleteBackgroundColor: theme.colors.gamificationDotApprovedColor,
    dotCompleteIconColor: 'white',
}
//Gamification DefaultBackgroundGradient
export const GamificationDefaultBackgroundGradient = [
    theme.colors.colorPrimary,
    theme.colors.colorSecondary,
    theme.colors.colorTertiary,
]

// Gamification Points Gradients
export const pointsGradientEnabled = /** @type {const} */ (['#70C783', '#677EF100'])
export const pointsGradientDisabled = /** @type {const} */ (['#645FF9', '#645FF900'])
export const pointsGradientCurrent = /** @type {const} */ ([
    '#ffffff',
    '#ffffff80',
    '#ffffff00',
])

// Gamification JackpotButton
export const JackPotGradient = /** @type {const} */ (['#4539EF', '#D93633'])

export const GamificationGameTheme = {
    imageSelectedIconColor: theme.colors.colorPrimary,
    imageCorrectIconColor: 'green',
    imageIncorrectIconColor: 'red',
    imageCorrectNotSelectedIconColor: 'green',
    fillBlanksTextColor: theme.colors.alert,
    fillBlanksOptionUnselectedBackground: 'white',
    fillBlanksOptionBackground: theme.colors.colorPrimary,
    fillBlanksSelectedText: 'white',
    feedBackTitle: '#FFF736',
    interModalButtonBackground: theme.colors.colorPrimary,
    interModalButtonTextColor: 'white',
}
export const GamificationFinishTheme = {
    exitButtonTextColorAp: 'white',
    exitButtonTextColorDis: 'white',
}
export const GamificationRouletteTheme = {
    playButtonTextColor: '#1B1B2B',
    gradientTextColors: /** @type {const} */ (['#FFFFFF', '#FFFCCB']),
}

export const RankingMainColor = theme.colors.colorPrimary
export const RankingMainColorOpacity = RankingMainColor + '33' //Opacidad 20%
const RankingSecondaryColor = theme.colors.colorSecondary

export const RankingTheme = {
    tabsSelectedColor: RankingMainColor + '33',
    tabsUnselectedColor: RankingMainColor + '14',
    podiumUserTextcolor: theme.colors.textPrimary,
    podiumUserPointsTextcolor: theme.colors.colorSecondary,
    rankingPositionTextColor: '#6890F6',
    rankingUserTextColor: theme.colors.textPrimary,
    rankingPointsBorderColor: theme.colors.lightGray,
    rankingGradient: ['#ffffff', '#ffffff'],
    triviaCardTextColor: 'white',
    triviaGameNextButtonBackgroundColor: theme.colors.colorSecondary,
}

//Store KPI Indicator
export const StoreKPIIndicatorTheme = {
    progressUnfilledCollor: theme.colors.colorTertiary,
    progressFilledColor: 'white',
}

export const RouletteComponentTheme = {
    centerStop0color: '#FFDE39',
    centerStop23Color: '#FFFFFF',
    centerStop43Color: '#F7B307',
    centerStop70Color: '#C7930D',
    centerStop100Color: '#F9DF9C',
}

export const ProfileDividerTheme = {
    shadowColors: ['#FAFAFA', '#BEB9CB'],
    color: '#DADADA',
}

export const CampaingViewRelevGradient = /** @type {const} */ ([
    '#7f7af9',
    theme.colors.linearGradientGreenStart,
])

// Shimmer global theme
export const ShimmerTheme = {
    duration: 1100,
    baseColor: '#EDEFF2',
    highlightColor: '#F9FBFD',
}
export const BenefitMainColor = theme.colors.colorPrimary
const BenefitSecondaryColor = theme.colors.colorSecondary

export const BenefitTheme = {
    benefitGradient: ['#ffffff', '#ffffff'],
    tabsSelectedColor: withOpacity(BenefitMainColor, 0.2), //Opacidad 20%
    tabsUnselectedColor: BenefitMainColor + '14', //Opacidad 8%
}

export const MyAdvanceTheme = {
    myAdvanceGradient: ['#ffffff', '#ffffff'],
    tabsSelectedColor: BenefitMainColor + '33', //Opacidad 20%
    tabsUnselectedColor: BenefitMainColor + '14', //Opacidad 8%
}

// Store Detail View
export const storeDetailOrder = [
    STORE_VIEW_MAP.INDICATORS,
    STORE_VIEW_MAP.PERFECT_STORE,
    STORE_VIEW_MAP.EXECUTION,
    STORE_VIEW_MAP.VOUCHERS,
]
